<template>
  <vs-popup 
    class="mt-8" 
    title="Image Zoom" 
    fullscreen 
    :active.sync="popupActive" 
    v-if="isActive"
  >
    <ImageEditor 
      :base64Image="image" 
      @StateChanged="onStateChanged"
      @ImageSave="onImageSave"
    />
  </vs-popup>
</template>

<script>
import ImageEditor from '@/views/components/extra-components/imageeditor/ImageEditor.vue'

export default {
  name: 'ImageEditorPopup',
  
  components: {
    ImageEditor
  },

  props: {
    isActive: {
      type: Boolean,
      required: true
    },
    image: {
      type: String,
      default: null
    }
  },

  computed: {
    popupActive: {
      get() {
        return this.isActive
      },
      set(value) {
        this.$emit('update:isActive', value)
      }
    }
  },

  methods: {
    onStateChanged(state) {
      this.$emit('state-changed', state)
    },
    onImageSave(image) {
      this.$emit('image-save', image)
      this.popupActive = false
    }
  }
}
</script> 